<div class="main-wrapper quote-assist-version">
  <!-- Loading Overlay -->
  <div class="full-page-overlay" *ngIf="showPageDataLoading">
    <div class="rfqLoader"></div>
  </div>
</div> 